import { LinearProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";

export default function PageProgressBar() {
  const location = useLocation();
  const [progress, setProgress] = useState(0); // 控制進度條進度
  const [isPageReady, setIsPageReady] = useState(false);

  useEffect(() => {
    let timer;
    const minTime = 500; // 最小顯示時間 0.5 秒
    const startTime = Date.now(); // 記錄開始時間

    // 初始化進度條狀態
    setProgress(0);
    setIsPageReady(false);

    const simulateProgress = () => {
      timer = setInterval(() => {
        setProgress((prev) => {
          if (prev < 90) {
            return prev + 1; // 緩慢增加到 90
          }
          return prev; // 停止在 90%
        });
      }, minTime / 90); // 確保 0-90 用時接近 2 秒
    };

    const checkReadyState = () => {
      if (document.readyState === "complete") {
        const elapsedTime = Date.now() - startTime;
        const remainingTime = Math.max(0, minTime - elapsedTime);

        setTimeout(() => {
          setProgress(100); // 將進度條設置為 100%
          setTimeout(() => {
            setIsPageReady(true); // 隱藏進度條
          }, 500); // 顯示一段時間後隱藏
        }, remainingTime);
      } else {
        document.addEventListener("readystatechange", () => {
          if (document.readyState === "complete") {
            checkReadyState();
          }
        });
      }
    };

    simulateProgress();
    checkReadyState();

    return () => {
      clearInterval(timer); // 清理進度模擬定時器
      document.removeEventListener("readystatechange", checkReadyState); // 清理事件
    };
  }, [location.pathname]);

  return (
    !isPageReady && ( // 隱藏進度條（完全加載後）
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 9999,
        }}
      >
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: "3px",
            borderRadius: "0px",
            backgroundColor: "#E6E6E6",
            "& .MuiLinearProgress-bar": {
              background:
                "linear-gradient(270deg, #CF8BF3 0%, #B2B5FB 50%, #94B0F7 95%)", // 漸變色
              borderRadius: "4px", // 進度條圓角
            },
          }}
        />
      </div>
    )
  );
}
